import { Chain } from '@/contract/rpc'
import { IChainId } from '@/interface'
import { Http } from '@/plugins/axios'
import generateKey from '@/plugins/generateKey'
import CryptoJS from 'crypto-js'
import { useRecaptcha } from './recaptcha'

/**
 * 生成16位随机字节
 * @returns
 */
export function generateRandomByte () {
  return CryptoJS.lib.WordArray.random(16)
  // return CryptoJS.enc.Hex.parse('5c75564e399ce15e7c79a12e8e428746')
}

/**
 * 生成密文
 * @param id 红包id
 * @returns
 */
export function generateAesCrypto (msg: string) {
  const key = CryptoJS.enc.Hex.parse(generateKey())

  const iv = generateRandomByte()

  // const msg = CryptoJS.enc.Hex.parse(id.replace(/^0x(.*)/, '$1'))

  const result = CryptoJS.AES.encrypt(msg, key, {
    iv
  })

  return CryptoJS.enc.Hex.stringify(iv.concat(result.ciphertext))
}

export async function getNonceAPIHandler (redPackId:string, chainId: Chain | string, captcha: string, input: string) {
  const getNonce = await Http.get<{
    // 红包 ID
    envelopeId: string;
    // 随机数
    nonce: string;
  }>({
    url: '/redenvelope/v1/nonce',
    params: {
      chainId,
      envelopeId: redPackId,
      input,
      captcha
    }
  })

  return getNonce.nonce
}
